export default __webpack_public_path__ + "static/media/WorkSans-Bold.d8de505f.ttf";